const TONE = {
  none: "bg-slate-500/15 text-slate-500",
  pending: "bg-status-warning-bg text-status-warning",
  approved: "bg-status-success-bg text-status-success",
  declined: "bg-status-danger-bg text-status-danger",
};

/** Where a verification stands: not submitted, pending review, approved or declined. */
export default function KycStatusBadge({ status = "none", t, className = "" }) {
  return (
    <span
      className={`inline-flex items-center rounded-radius-xs px-2 py-0.5 text-caption-1-semibold ${
        TONE[status] || TONE.none
      } ${className}`}
    >
      {t(`kyc.status.${TONE[status] ? status : "none"}`)}
    </span>
  );
}
